import React from 'react';
import { Outlet } from 'react-router-dom';

import useModal from 'hooks/useModal';

const RouteProvider = () => {
  const { modals } = useModal();
  return (
    <>
      {modals.map((modal) => (
        <React.Fragment key={`modal/${modal.key}`}>{modal.component}</React.Fragment>
      ))}
      <Outlet />
    </>
  );
};

export default RouteProvider;
